import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { cn } from '../../lib/cn';

/**
 * Main application layout with sidebar navigation.
 * Provides consistent structure for all admin pages.
 */
export function AppLayout() {
  return (
    <div className="min-h-screen bg-bg">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area - offset by sidebar width */}
      <main
        className={cn(
          'ml-sidebar min-h-screen',
          'flex flex-col'
        )}
      >
        {/* Page content */}
        <Outlet />
      </main>
    </div>
  );
}
